import { Box, Image } from "@chakra-ui/react";
import Footer from "./footer";
import Navbar from "./navbar";
const PublicLayout = ({ children, color, bg, register = true, type }) => {
  return (
    <Box
      w="100%"
      // h="100%"
      // minH="100vh"
      className="public"
      overflowX="hidden"
      justifyContent="space-between"
    >
      <Image
        src={require("../../../assets/Vector 6.jpg")}
        position="absolute"
        zIndex="-1"
        left="-80px"
      />
      <Box h="100px" w="100%">
        <Navbar color={color} bg={bg} register={register} type={type} />
      </Box>
      <Image
        src={require("../../../assets/Vector.jpg")}
        position="absolute"
        right="-80px"
        top=" 40%"
        zIndex="-1"
        display={{ base: "none", md: "block" }}
      />
      {children}

      {/* <Footer /> */}
    </Box>
  );
};

export default PublicLayout;
